/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AppointmentCard from 'DesignSystem/AppointmentCard/index'
import AppointmentType from './AppointmentType/index'
import PatientName from './PatientName/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'
import Time from './Time/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/RescheduleQueue/AppointmentQueue/Content/Appointment",
  onMouseDown
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let eventAppointmentTypeDisplayColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.type.display_color_id',
format: fromFormat.appointmentTypeColor,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 draggable={true}
 onMouseDown={onMouseDown}
 style={{'--g-1-dUIJ5': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block appointment-queue-item ${styles.Horizontal}`}
>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<AppointmentCard
  viewPath={`${viewPath}/AppointmentCard`}
 cursor="pointer"
 paddingTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 width={225}
 data="event.appointment.type.display_color_id"
 format="/Data/format.js appointmentTypeColor"
 appointmentColor={eventAppointmentTypeDisplayColorIdValueData}
>
{childProps => (
<React.Fragment>
<PatientName
{...childProps}
  viewPath={`${viewPath}/PatientName`}
/>
<AppointmentType
{...childProps}
  viewPath={`${viewPath}/AppointmentType`}
/>
<Time
{...childProps}
  viewPath={`${viewPath}/Time`}
/>
</React.Fragment>
)}
</AppointmentCard>
</div>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</div>
{children}
</React.Fragment>)
}